(() => {
  if (customElements.get('cart-progress')) return;
 
  const KEY = 'qg-cart-progress-seg';
  const COLORS = ['#7f1717', '#ffc21a', '#e8a0a0', '#c98b6b', '#f4d9c6'];
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
 
  const read = () => {
    try { const v = sessionStorage.getItem(KEY); return v === null ? null : parseInt(v, 10); }
    catch (e) { return null; }
  };
  const write = (v) => { try { sessionStorage.setItem(KEY, String(v)); } catch (e) {} };

  if (read() === null && !document.querySelector('cart-progress')) write(0);
 
  const rand = (a, b) => a + Math.random() * (b - a);
 
  const balloonSVG = (c) => `
    <svg viewBox="0 0 40 64" width="38" height="61" aria-hidden="true">
      <path d="M20 2C9.5 2 3 10.5 3 20c0 12.5 10 22 17 24 7-2 17-11.5 17-24C37 10.5 30.5 2 20 2z" fill="${c}"/>
      <path d="M17.5 44.5 20 48l2.5-3.5z" fill="${c}"/>
      <path d="M20 48c-3 4 3 8 0 14" stroke="#9a8f8f" stroke-width="1" fill="none"/>
      <ellipse cx="13" cy="15" rx="3" ry="6.5" fill="#fff" opacity=".35" transform="rotate(-20 13 15)"/>
    </svg>`;
 
  class CartProgress extends HTMLElement {
    static get observedAttributes() { return ['data-seg']; }
 
    connectedCallback() { this.check(); }
 
    attributeChangedCallback(name, oldV, newV) {
      if (oldV !== null && oldV !== newV) this.check(); // morph-style updates
    }
 
    check() {
      const seg = parseInt(this.dataset.seg, 10);
      if (Number.isNaN(seg)) return;
      const prev = read();
      write(seg);
      if (prev === null || seg <= prev) return; // first visit or went down: no party
      this.whenVisible(() => this.celebrate(seg, prev));
    }
 
    // Wait until the drawer has actually slid open before celebrating.
    whenVisible(fn) {
      const io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          io.disconnect();
          setTimeout(fn, 250);
        }
      }, { threshold: 0.5 });
      io.observe(this);
    }
 
    celebrate(seg, prev) {
      const steps = this.querySelectorAll('.cart-progress__step');
      const step = steps[seg - 1];
      if (!step) return;
 
      const unlocked = [];
      for (let i = prev; i < seg; i++) {
        const l = steps[i] && steps[i].querySelector('.cart-progress__label');
        if (l) unlocked.push(l.textContent.trim());
      }
 
      step.classList.remove('is-just-unlocked');
      void step.offsetWidth; // restart animation
      step.classList.add('is-just-unlocked');
      setTimeout(() => step.classList.remove('is-just-unlocked'), 1400);
 
      // Overlay lives on <body> so a drawer re-render can't cut it short.
      const layer = document.createElement('div');
      layer.className = 'cp-celebrate';
      document.body.appendChild(layer);
 
      const icon = step.querySelector('.cart-progress__icon') || step;
      const r = icon.getBoundingClientRect();
      const ox = r.left + r.width / 2;
      const oy = r.top + r.height / 2;
 
      this.toast(layer, unlocked, this.getBoundingClientRect());
 
      if (!reduceMotion) {
        this.confetti(layer, ox, oy);
        this.balloons(layer);
      }
 
      setTimeout(() => layer.remove(), 4500);
    }
 
    toast(layer, labels, box) {
      const t = document.createElement('div');
      t.className = 'cp-toast';
      const what = labels.length > 1
        ? labels.slice(0, -1).join(', ') + ' & ' + labels[labels.length - 1]
        : labels[0];
      t.innerHTML = `<span aria-hidden="true">🎉</span> <strong></strong> unlocked!`;
      t.querySelector('strong').textContent = what;
      t.style.left = box.left + box.width / 2 + 'px';
      t.style.top = Math.max(12, box.top - 8) + 'px';
      layer.appendChild(t);
    }
 
    confetti(layer, ox, oy) {
      for (let i = 0; i < 42; i++) {
        const p = document.createElement('span');
        p.className = 'cp-confetti';
        p.style.left = ox + 'px';
        p.style.top = oy + 'px';
        p.style.background = COLORS[i % COLORS.length];
        if (i % 3 === 0) p.style.borderRadius = '50%';
        layer.appendChild(p);
 
        const angle = rand(0, Math.PI * 2);
        const dist = rand(50, 140);
        const dx = Math.cos(angle) * dist;
        const dy = Math.sin(angle) * dist - 40;
        const rot = rand(-540, 540);
        p.animate([
          { transform: 'translate(-50%,-50%) rotate(0deg)', opacity: 1 },
          { transform: `translate(${dx}px, ${dy}px) rotate(${rot}deg)`, opacity: 1, offset: 0.55 },
          { transform: `translate(${dx * 1.15}px, ${dy + 160}px) rotate(${rot * 1.6}deg)`, opacity: 0 }
        ], { duration: rand(1200, 1700), easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'forwards' });
      }
    }
 
    balloons(layer) {
      const host = this.closest('cart-drawer, .cart-drawer, .drawer__inner, dialog') || this;
      const box = host.getBoundingClientRect();
      const count = 6;
      for (let i = 0; i < count; i++) {
        const b = document.createElement('div');
        b.className = 'cp-balloon';
        b.innerHTML = balloonSVG(COLORS[i % COLORS.length]);
        const x = box.left + (box.width / count) * (i + rand(0.15, 0.85)) - 19;
        b.style.left = x + 'px';
        b.style.top = window.innerHeight + 10 + 'px';
        layer.appendChild(b);
 
        const rise = window.innerHeight + 120;
        const sway = rand(14, 26) * (i % 2 ? 1 : -1);
        b.animate([
          { transform: 'translate(0,0) rotate(0deg)' },
          { transform: `translate(${sway}px, ${-rise * 0.33}px) rotate(${sway / 3}deg)` },
          { transform: `translate(${-sway}px, ${-rise * 0.66}px) rotate(${-sway / 3}deg)` },
          { transform: `translate(${sway / 2}px, ${-rise}px) rotate(0deg)` }
        ], { duration: rand(2600, 3600), delay: i * 120 + rand(0, 200), easing: 'ease-in', fill: 'both' });
      }
    }
  }
 
  customElements.define('cart-progress', CartProgress);
})();
